import { baseApi } from "../baseApi";

export const adminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    postLogin: builder.mutation({
      query: (data) => ({
        url: `/api/method/jewellery.auric_api.login`,
        method: "POST",
        body: data,
      }),
    }),
    postLogout: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.logout`,
        method: "POST",
        body: data,
      }),
    }),
    updatePassword: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.change_password`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { 
  usePostLoginMutation,
  usePostLogoutMutation,
  useUpdatePasswordMutation 
} = adminApi;